// extracted by mini-css-extract-plugin
export default {"ac-search-result":"XhbfJLQDfkXxg5Kc6xvr","ac-search-result__title":"g3l8Qm9dZhtPgqkIambO"};